import script from "./KpiDashboard.vue?vue&type=script&setup=true&lang=js"
export * from "./KpiDashboard.vue?vue&type=script&setup=true&lang=js"

import "./KpiDashboard.vue?vue&type=style&index=0&id=70ad0e1a&lang=scss&scoped=true"

import exportComponent from "/var/www/application-mobile/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-70ad0e1a"]])

export default __exports__